(function () {
  'use strict';

  angular
    .module('neo.home.configuracio')
    .controller('ConfiguracioCtrl', ConfiguracioCtrl);

  function ConfiguracioCtrl($mdToast, $timeout, Configuracio, Distancies, tarifes, ajuntaments, distancies) {
    var vm = this;

    vm.tarifes = tarifes;
    vm.ajuntaments = ajuntaments;

    // Construir matriu NxN indexada per [originId][destinationId]
    vm.distanciaMatrix = {};

    // Pre-inicialitzar totes les cel·les a 0 perquè ng-model no doni error
    ajuntaments.forEach(function (o) {
      vm.distanciaMatrix[o.id] = {};
      ajuntaments.forEach(function (d) {
        if (o.id !== d.id) { vm.distanciaMatrix[o.id][d.id] = 0; }
      });
    });

    // Omplir amb els valors reals de l'API (dividir per 2: la BD guarda anada i tornada)
    distancies.forEach(function (d) {
      if (vm.distanciaMatrix[d.originId]) {
        vm.distanciaMatrix[d.originId][d.destinationId] = d.distanceKm / 2;
      }
    });

    vm.syncDistancia  = syncDistancia;
    vm.saveTarifes    = saveTarifes;
    vm.saveDistancies = saveDistancies;

    // Manté la simetria: quan s'edita A→B s'actualitza B→A automàticament
    function syncDistancia(originId, destId) {
      var km = vm.distanciaMatrix[originId][destId] || 0;
      vm.distanciaMatrix[destId][originId] = km;
    }

    function saveTarifes() {
      Configuracio.update(vm.tarifes, function () {
        showToast('Tarifes guardades correctament');
      }, function () {
        showToast('Error en guardar les tarifes');
      });
    }

    function saveDistancies() {
      var list = [];
      vm.ajuntaments.forEach(function (origin) {
        vm.ajuntaments.forEach(function (dest) {
          if (origin.id !== dest.id) {
            list.push({
              originId:      origin.id,
              destinationId: dest.id,
              distanceKm:    (vm.distanciaMatrix[origin.id][dest.id] || 0) * 2
            });
          }
        });
      });
      Distancies.update(list, function () {
        showToast('Distàncies guardades correctament');
      }, function () {
        showToast('Error en guardar les distàncies');
      });
    }

    function showToast(msg) {
      $mdToast.show(
        $mdToast.simple().textContent(msg).position('bottom right').hideDelay(3000)
      );
    }
  }
}());
